import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=4e247e8c&scoped=true"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=4e247e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e247e8c",
  null
  
)

export default component.exports